R = require 'ramda'
moment = require 'moment-timezone'

relativeTimeFor = (timezone, value) ->
  startOfDay = moment().tz(timezone).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).utc()
  endOfDay = moment().tz(timezone).set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999).utc()

  switch value
    when 'today'
      [startOfDay.toJSON().split('.')[0], endOfDay.toJSON().split('.')[0]]
    when 'tomorrow'
      [startOfDay.add(1, 'day').toJSON().split('.')[0], endOfDay.add(1, 'day').toJSON().split('.')[0]]
    when 'yesterday'
      [startOfDay.subtract(1, 'day').toJSON().split('.')[0], endOfDay.subtract(1, 'day').toJSON().split('.')[0]]
    when 'this_week'
      [startOfDay.set('day', 1).toJSON().split('.')[0], endOfDay.set('day', 7).toJSON().split('.')[0]]
    when 'next_week'
      [startOfDay.add(1, 'week').set('day', 1).toJSON().split('.')[0], endOfDay.add(1, 'week').set('day', 7).toJSON().split('.')[0]]
    when 'last_week'
      [startOfDay.subtract(1, 'week').set('day', 1).toJSON().split('.')[0], endOfDay.subtract(1, 'week').set('day', 7).toJSON().split('.')[0]]
    when 'last_week_today'
      [startOfDay.subtract(1, 'week').toJSON().split('.')[0], endOfDay.subtract(1, 'week').toJSON().split('.')[0]]

relativeUnitTimeFor = (timezone, count, unit) ->
  intervalStart = moment().tz(timezone).set('minute', 0).set('second', 0).set('millisecond', 0).utc()
  intervalEnd = moment().tz(timezone).set('minute', 59).set('second', 59).set('millisecond', 999).utc()
  switch unit
    when 'hour' then # noop
    when 'day'
      intervalStart.set('hour', 0)
      intervalEnd.set('hour', 23)
    when 'week'
      intervalStart.set('hour', 0).set('day', 1)
      intervalEnd.set('hour', 23).set('day', 7)
    when 'month'
      intervalStart.set('hour', 0).set('date', 1)
      intervalEnd.set('hour', 23).set('date', 1).subtract(1, 'day').add(1, 'month')
    else
      throw "Unit #{unit} is not allowed"

  [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count, unit).toJSON().split('.')[0]]

relativeBeforeUnitTimeFor = (timezone, count, unit) ->
  intervalStart = moment().tz(timezone).utc()
  intervalEnd = moment().tz(timezone).utc()
  switch unit
    when 'hour'
      [intervalEnd.subtract(count+30*24, unit).toJSON().split('.')[0], intervalStart.subtract(count, unit).toJSON().split('.')[0]]
    when 'day'
      [intervalEnd.subtract(count+30, unit).toJSON().split('.')[0], intervalStart.subtract(count, unit).toJSON().split('.')[0]]
    when 'week'
      [intervalEnd.subtract(count+5, unit).toJSON().split('.')[0], intervalStart.subtract(count, unit).toJSON().split('.')[0]]
    when 'month'
      [intervalEnd.subtract(count+1, unit).toJSON().split('.')[0], intervalStart.subtract(count, unit).toJSON().split('.')[0]]
    else
      [intervalEnd.subtract(count, unit).toJSON().split('.')[0], intervalStart.subtract(count, unit).toJSON().split('.')[0]]

relativeAfterUnitTimeFor = (timezone, count, unit) ->
  intervalStart = moment().tz(timezone).utc()
  intervalEnd = moment().tz(timezone).utc()
  switch unit
    when 'hour'
      [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count+30*24, unit).toJSON().split('.')[0]]
    when 'day'
      [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count+30, unit).toJSON().split('.')[0]]
    when 'week'
      [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count+5, unit).toJSON().split('.')[0]]
    when 'month'
      [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count+1, unit).toJSON().split('.')[0]]
    else
      [intervalStart.add(count, unit).toJSON().split('.')[0], intervalEnd.add(count, unit).toJSON().split('.')[0]]
  
relativeShiftTimeFor = (timezone, value) ->
  startOfDay = moment().tz(timezone).set('hour', 4).set('minute', 0).set('second', 0).set('millisecond', 0).utc()
  endOfDay = moment().tz(timezone).add(1, 'day').set('hour', 3).set('minute', 59).set('second', 59).set('millisecond', 999).utc()

  switch value
    when 'today'
      [startOfDay.toJSON().split('.')[0], endOfDay.toJSON().split('.')[0]]
    when 'yesterday'
      [startOfDay.subtract(1, 'day').toJSON().split('.')[0], endOfDay.subtract(1, 'day').toJSON().split('.')[0]]
    when '2_days_ago'
      [startOfDay.subtract(2, 'day').toJSON().split('.')[0], endOfDay.subtract(2, 'day').toJSON().split('.')[0]]

relativeNowUnitTimeFor = (timezone, count, unit) ->
  intervalStart = moment().tz(timezone).utc()
  intervalEnd = moment().tz(timezone).utc()
  [intervalStart.toJSON().split('.')[0], intervalEnd.add(count, unit).toJSON().split('.')[0]]

relativeUntilNowUnitTimeFor = (timezone, count, unit) ->
  intervalStart = moment().tz(timezone).utc()
  intervalEnd = moment().tz(timezone).utc()
  [intervalEnd.subtract(count, unit).toJSON().split('.')[0], intervalStart.toJSON().split('.')[0]]

exactTimeFor = (timezone, startDate) ->
  dayStart = moment(startDate).tz(timezone).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).utc()
  dayEnd = moment(startDate).tz(timezone).set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999).utc()
  [dayStart.toJSON().split('.')[0], dayEnd.toJSON().split('.')[0]]

exactTime = (timezone, startDate, endDate) ->
  dayStart = moment(startDate).tz(timezone).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).utc()
  dayEnd = moment(endDate).tz(timezone).set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999).utc()
  [dayStart.toJSON().split('.')[0], dayEnd.toJSON().split('.')[0]]

isDateTimeCondition = R.where field: R.contains R.__, ["time", "created_at", "order_at", "placed_at", "pickup_at", "delivery_at", "fire_at", "due_at", "confirmation_at"]

isExactRestaurantCondition = R.anyPass([R.whereEq(field: 'restaurant_id'), R.whereEq(field: 'restaurant_name', op: 'equal'), R.whereEq(field: 'restaurant_name', op: '!equal')])
isExactChannelCondition = R.anyPass([R.whereEq(field: 'channel_id'), R.whereEq(field: 'channel_name', op: 'equal'), R.whereEq(field: 'channel_name', op: '!equal')])
isDriverCondition = R.anyPass([R.whereEq(field: 'rds.driver_id', op: 'equal'), R.whereEq(field: 'rds.driver_id', op: '!equal')])
isDeliveryServiceCondition = R.anyPass([R.whereEq(field: 'rds.delivery_service', op: 'equal'), R.whereEq(field: 'rds.delivery_service', op: '!equal')])

transformCondField = (condition) ->
  switch condition.field
    when 'uuid'
      'short_uuid'
    when 'code'
      'ivr_code'
    when 'service_id'
      'order_type'
    when 'tender_id'
      'payment_type'
    when 'card_number'
      'card_4_digits'
    when 'restaurant_name'
      'restaurant_id'
    when 'time'
      'order_at'
    when "pickup_at", 'delivery_at'
      'order_at'
    when 'due_at'
      "order_at"
    when "confirmation_at"
      "updated_at"
    when 'channel_name'
      'channel_id'
    else
      condition.field

transformCondOp = (op) ->
  switch op
    when 'equal'
      'any_of'
    when '!equal'
      'none_of'
    when 'contain'
      'contains_any_of'
    when 'prefix'
      'contains_any_of'
    when '!contain'
      'contains_none_of'
    when 'contains'
      'any_of'
    else
      op

conditionToQuery = (timezone, condition) ->
  condField = {field: transformCondField(condition)}
  condOp = {op: transformCondOp(condition.op)}
  if isDateTimeCondition condition
    switch condition.op
      when '~=' # date is
        R.mergeAll [condField, op: "in_ranges", value: relativeTimeFor(timezone, condition.value)]
      when '~<>' # date is in count unit
        R.mergeAll [condField, op: "in_ranges", value: relativeUnitTimeFor(timezone, condition.value.count, condition.value.unit)]
      when 'gt'
        R.mergeAll [condField, op: "in_ranges", value: relativeAfterUnitTimeFor(timezone, condition.value.count, condition.value.unit)]
      when 'lt'
        R.mergeAll [condField, op: "in_ranges", value: relativeBeforeUnitTimeFor(timezone, condition.value.count, condition.value.unit)]
      when 'within'
        R.mergeAll [condField, op: "in_ranges", value: relativeNowUnitTimeFor(timezone, condition.value.count, condition.value.unit)]
      when 'within past'
        R.mergeAll [condField, op: "in_ranges", value: relativeUntilNowUnitTimeFor(timezone, condition.value.count, condition.value.unit)]
      when 'in'
        R.mergeAll [condField, op: "in_ranges", value: exactTime(timezone, condition.value.startDate, condition.value.endDate)]
      when '!in'
        R.mergeAll [condField, op: "in_ranges", value: exactTime(timezone, condition.value.startDate, condition.value.endDate)]
      when 's~='
        R.mergeAll [condField, op: "in_ranges", value: relativeShiftTimeFor(timezone, condition.value)]
      when 'between'
        R.mergeAll [condField, op: "in_ranges", value: exactTime(timezone, condition.value.startDate, condition.value.endDate)]
      when '!between'
        R.mergeAll [condField, op: "not_in_ranges", value: exactTime(timezone, condition.value.startDate, condition.value.endDate)]
      when 'is'
        R.mergeAll [condField, op: "in_ranges", value: exactTimeFor(timezone, condition.value.startDate)]
      when '!is'
        R.mergeAll [condField, op: "not_in_ranges", value: exactTimeFor(timezone, condition.value.startDate)]
      else # for <> or ><
        R.mergeAll [condField, R.pick(['op', 'value'], condition)]
  else if isExactRestaurantCondition condition
    R.mergeAll [condField, condOp , value: condition.value.id]
  else if isExactChannelCondition condition
    R.mergeAll [condField, condOp , value: condition.value.id]
  # else if isStringMatchCondition condition
  #   R.merge condFieldOp, op: transformCondOp(condition.op), value: condition.value
  else if isDriverCondition condition
    return
    # R.merge R.pick(['op'], condition), field: 'rds.driver_id', value: condition.value.id
  else if isDeliveryServiceCondition condition
    return
  else if condition.field == 'restaurant_name' || condition.field == 'channel_name'
    R.mergeAll []
  else if condField.field == 'short_uuid' || condField.field == 'ivr_code'
    if condOp.op == 'contains_any_of'
      R.mergeAll [condField, {op: "any_of"}, R.pick(['value'], condition)]
    else if condOp.op == 'contains_none_of'
      R.mergeAll [condField, {op: "none_of"}, R.pick(['value'], condition)]
    else
       R.mergeAll [condField, condOp, R.pick(['value'], condition)]
  else
    R.mergeAll [condField, condOp, R.pick(['value'], condition)]

conditionsToQuery = (conditions, timezone = "EET") ->
  res = translateConditions conditions, timezone
  final = transformConditions res
  conditions: final
  
translateConditions = (conditions, timezone = "EET") ->
  query = R.map conditionToQuery.bind(@, timezone), conditions
  onlyValid = R.filter (cond) -> cond.value
  onlyValid query

mergeArrays = (conditions, newCond) ->
  if Array.isArray(conditions[0])
    conditions.push(newCond)
    conditions
  else
    temp = []
    temp.push(conditions)
    temp.push(newCond)
    temp

transformConditions = (conditions) ->
  i = 0
  while i < conditions.length
    j = i + 1
    while j < conditions.length
      if conditions[i]['field'] == conditions[j]['field'] and conditions[i]['op'] == conditions[j]['op']
        if Array.isArray(conditions[i]['value'])
          if Array.isArray(conditions[j]['value'])
            conditions[i]['value'] = mergeArrays(conditions[i]['value'], conditions[j]['value'])
          else
            conditions[i]['value'].push conditions[j]['value']
        else
          values = []
          values.push conditions[i]['value']
          values.push conditions[j]['value']
          conditions[i]['value'] = values
        conditions.splice j, 1
        j = j - 1
      j++
    i++
  k = 0
  while k < conditions.length
    if isDateTimeCondition conditions[k]
      if !Array.isArray(conditions[k]['value'][0])
        valueList = [conditions[k]['value']]
        conditions[k]['value'] = valueList
    if !Array.isArray(conditions[k]['value'])
      resp = []
      resp.push conditions[k]['value']
      conditions[k]['value'] = resp
    k++
  conditions

module.exports =
  conditionsToQuery: conditionsToQuery
  translateConditions: translateConditions
